export default
{
    name: 'app-partners',

    props:
    {
        contentGlobal: { type: Object }
    },

    created()
    {
        this._toLoad = this.contentGlobal.partners.length
    },

    methods:
    {
        _onContentLoaded()
        {
            this._toLoad--
            if (this._toLoad < 1)
            {
                this.$emit('load', this)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-partners/script.js